import React from 'react';

import strings from 'app/locales/results';

import styles from './styles.css';

const FinalText = ({ goodGuyPercent }) => (
  <div className={styles.container}>
    <p className={styles.text}>{strings.finalText(100 - goodGuyPercent)}</p>
  </div>
);

export default FinalText;



// WEBPACK FOOTER //
// ./src/components/ResultsContainer/FinalText/index.js